import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { installSessionLogCollector } from "@/lib/sessionLogCollector"
import { initSentry } from "@/lib/sentry"
import { initPostHog } from "@/lib/posthog"

import "./index.css"
import App from "./App.tsx"

installSessionLogCollector();
initSentry();
initPostHog();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
